/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { BulkUpdateConfigDTO } from '../models';
// @ts-ignore
import type { GetApplicationConfigWithSecrets200Response } from '../models';
// @ts-ignore
import type { UpdateConfigDTO } from '../models';
/**
 * DebugApi - axios parameter creator
 */
export const DebugApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint allows bulk updating the application config. It is intended for debugging purposes only and should not be used in production environments.
         * @summary Bulk update the application config
         * @param {BulkUpdateConfigDTO} bulkUpdateConfigDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateApplicationConfig: async (bulkUpdateConfigDTO: BulkUpdateConfigDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkUpdateConfigDTO' is not null or undefined
            assertParamExists('bulkUpdateApplicationConfig', 'bulkUpdateConfigDTO', bulkUpdateConfigDTO)
            const localVarPath = `/api/nora/debug/config/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateConfigDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns the application config, with sensitive information hidden.
         * @summary Get the application config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/debug/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns each application config entry with its schema metadata and current value, including secret values
         * @summary Get the application config entries with secrets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationConfigWithSecrets: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/debug/config/secret`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint allows updating the application config. It is intended for debugging purposes only and should not be used in production environments.
         * @summary Update the application config
         * @param {UpdateConfigDTO} updateConfigDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicationConfig: async (updateConfigDTO: UpdateConfigDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateConfigDTO' is not null or undefined
            assertParamExists('updateApplicationConfig', 'updateConfigDTO', updateConfigDTO)
            const localVarPath = `/api/nora/debug/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateConfigDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DebugApi - functional programming interface
 */
export const DebugApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DebugApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint allows bulk updating the application config. It is intended for debugging purposes only and should not be used in production environments.
         * @summary Bulk update the application config
         * @param {BulkUpdateConfigDTO} bulkUpdateConfigDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateApplicationConfig(bulkUpdateConfigDTO: BulkUpdateConfigDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateApplicationConfig(bulkUpdateConfigDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DebugApi.bulkUpdateApplicationConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint returns the application config, with sensitive information hidden.
         * @summary Get the application config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApplicationConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApplicationConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DebugApi.getApplicationConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint returns each application config entry with its schema metadata and current value, including secret values
         * @summary Get the application config entries with secrets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApplicationConfigWithSecrets(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetApplicationConfigWithSecrets200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApplicationConfigWithSecrets(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DebugApi.getApplicationConfigWithSecrets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint allows updating the application config. It is intended for debugging purposes only and should not be used in production environments.
         * @summary Update the application config
         * @param {UpdateConfigDTO} updateConfigDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateApplicationConfig(updateConfigDTO: UpdateConfigDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateApplicationConfig(updateConfigDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DebugApi.updateApplicationConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DebugApi - factory interface
 */
export const DebugApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DebugApiFp(configuration)
    return {
        /**
         * This endpoint allows bulk updating the application config. It is intended for debugging purposes only and should not be used in production environments.
         * @summary Bulk update the application config
         * @param {DebugApiBulkUpdateApplicationConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateApplicationConfig(requestParameters: DebugApiBulkUpdateApplicationConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.bulkUpdateApplicationConfig(requestParameters.bulkUpdateConfigDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint returns the application config, with sensitive information hidden.
         * @summary Get the application config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationConfig(options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.getApplicationConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint returns each application config entry with its schema metadata and current value, including secret values
         * @summary Get the application config entries with secrets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationConfigWithSecrets(options?: RawAxiosRequestConfig): AxiosPromise<GetApplicationConfigWithSecrets200Response> {
            return localVarFp.getApplicationConfigWithSecrets(options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint allows updating the application config. It is intended for debugging purposes only and should not be used in production environments.
         * @summary Update the application config
         * @param {DebugApiUpdateApplicationConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicationConfig(requestParameters: DebugApiUpdateApplicationConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.updateApplicationConfig(requestParameters.updateConfigDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bulkUpdateApplicationConfig operation in DebugApi.
 */
export interface DebugApiBulkUpdateApplicationConfigRequest {
    readonly bulkUpdateConfigDTO: BulkUpdateConfigDTO
}

/**
 * Request parameters for updateApplicationConfig operation in DebugApi.
 */
export interface DebugApiUpdateApplicationConfigRequest {
    readonly updateConfigDTO: UpdateConfigDTO
}

/**
 * DebugApi - object-oriented interface
 */
export class DebugApi extends BaseAPI {
    /**
     * This endpoint allows bulk updating the application config. It is intended for debugging purposes only and should not be used in production environments.
     * @summary Bulk update the application config
     * @param {DebugApiBulkUpdateApplicationConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bulkUpdateApplicationConfig(requestParameters: DebugApiBulkUpdateApplicationConfigRequest, options?: RawAxiosRequestConfig) {
        return DebugApiFp(this.configuration).bulkUpdateApplicationConfig(requestParameters.bulkUpdateConfigDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint returns the application config, with sensitive information hidden.
     * @summary Get the application config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApplicationConfig(options?: RawAxiosRequestConfig) {
        return DebugApiFp(this.configuration).getApplicationConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint returns each application config entry with its schema metadata and current value, including secret values
     * @summary Get the application config entries with secrets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getApplicationConfigWithSecrets(options?: RawAxiosRequestConfig) {
        return DebugApiFp(this.configuration).getApplicationConfigWithSecrets(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint allows updating the application config. It is intended for debugging purposes only and should not be used in production environments.
     * @summary Update the application config
     * @param {DebugApiUpdateApplicationConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateApplicationConfig(requestParameters: DebugApiUpdateApplicationConfigRequest, options?: RawAxiosRequestConfig) {
        return DebugApiFp(this.configuration).updateApplicationConfig(requestParameters.updateConfigDTO, options).then((request) => request(this.axios, this.basePath));
    }
}

